import _ from 'lodash';
import moment from 'moment';
import { selectors as invoiceSelectors } from '../modules/customer/profile/invoices/'
import { apiService, salesApiService, cmsService } from './bootstrap';
import { utcToDisplayDate, displayDateToUtc, displayDateToShortDate } from './formatting';

export const checkout = (id) => salesApiService.request({
    url: `/basket/${id}/checkout`,
    method: 'POST'
});

export const checkCoverage = (id, type) => salesApiService.request({
    url: `/basket/${id}/address/${type}/coverage`,
    method: 'POST',
    parse: true
});

export const clearAddress = (id, type) => salesApiService.request({
    url: `/basket/${id}/address/${type}`,
    method: 'DELETE'
});

export const createBasket = () => salesApiService.request({
    url: '/basket',
    method: 'POST',
    parse: true
});

export const findBaskets = searchCriteria => salesApiService.request({
    url: `/basket?email=${searchCriteria.email.value}`,
    method: 'GET',
    parse: true,
    onResult: result => _.sortBy(result, ['createdAt']).map(item => _.assign({}, item, {
        createdAt: utcToDisplayDate(item.createdAt)
    }))
});

export const findCustomer = mobilePhone => apiService.request({
    url: `/customers?mobilePhone=${mobilePhone}`,
    method: 'GET',
    parse: true
});

export const findCustomerById = id => apiService.request({
    url: `/customers/${id}`,
    method: 'GET',
    parse: true,
    onResult: result => _.assign({}, result, {
        birthDate: utcToDisplayDate(result.birthDate),
        customerClass: result.class
    })
});

export const getCustomerOTTStatus = id => apiService.request({
    url: `/customers/${id}/OTTStatus`,
    method: 'GET',
    parse: true,
});

export const customerLookup = searchCriteria => {
    const queryString = _.entries(searchCriteria).map(([prop, value]) => prop + "=" + value.value).join("&");

    return apiService.request({
        url: `/customers?${queryString}`,
        method: 'GET',
        parse: true
    });
}

//Seems its not needed
// export const getInvoicesForCustomer = customerId => apiService.request({
//     url: `/customers/${customerId}/invoices`,
//     method: 'GET',
//     parse: true,
//     onResult: result => _.map(result, invoice => _.assign({}, invoice, {
//         dueDate: utcToDisplayDate(invoice.dueDate)
//     }))
// });

export const getInvoices = customerId => apiService.request({
    url: `/customers/${customerId}/invoices`,
    method: 'GET',
    parse: true,
    onResult: result => _.map(result, invoice => _.assign({}, invoice, {
        dueDate: utcToDisplayDate(invoice.dueDate),
        pdfAvailable: invoiceSelectors.isPdfAvailable(invoice) 
    }))
});

export const getAvailableInvocePdfs = customerId => apiService.request({
    url: `/availableinvoices?customerId=${customerId}`,
    method: 'GET',
    parse: true
});

export const getInvocePdf = (customerId, invoiceId) => apiService.requestFile({
    url: `/invoicefilestream?customerId=${customerId}&invoiceId=${invoiceId}`,
    method: 'GET',
    filename: `Faktura ${invoiceId}.pdf`,
});

export const getDevices = serialNumber => apiService.request({
    url: `/devices?serialNumber=${serialNumber}`,
    method: 'GET',
    parse: true
});

export const getFinancialBalance = customerId => apiService.request({
    url: `/customers/${customerId}/financialbalance`,
    method: 'GET',
    parse: true,
});

export const getSoftwareProducts = customerId => apiService.request({
    url: `/customers/${customerId}/softwareproducts`,
    method: 'GET',
    parse: true,
    onResult: result => _.map(result, product => _.assign({}, product, {
        contractEndDate: utcToDisplayDate(product.contractEndDate),
        contractStartDate: utcToDisplayDate(product.contractStartDate),
    }))
});

export const getHardwareProducts = customerId => apiService.request({
    url: `/customers/${customerId}/hardwareproducts`,
    method: 'GET',
    parse: true,
    onResult: result => _.map(result, product => _.assign({}, product, {
        contractEndDate: utcToDisplayDate(product.contractEndDate),
        contractStartDate: utcToDisplayDate(product.contractStartDate),
        isToCancel: false,
    }))
});

export const getHardwareProductDetails = (productId, serialNumber) => apiService.request({
    url: `/products/${productId}/HardwareProductDetails?serialNumber=${serialNumber}`,
    method: 'GET',
    parse: true,
    onResult: result => _.assign({}, result, {
        deviceId: productId,
        serialNumber
    })
});

export const getSmb2FirmwareVersion = (serialNumber) => apiService.request({
    url: `/hardwareproducts/${serialNumber}/firmwareversion`,
    method: 'GET',
    parse: true,
    onResult: result => _.assign({}, result, {
        smb2FirmwareVersion : result,
        serialNumber,
    })
});

export const sendSMS = (customerId, mobilePhone, smsContent) => apiService.request({
    url: `/sms`,
    method: 'POST',
    payload: {
        customerId,
        smsContent,
        mobilePhone
    }
});

export const saveContact = (comment, customerId) => apiService.request({
    url: `/contacts`,
    method: 'POST',
    payload: {
        customerId,
        comment
    }
});

export const updateCustomer = (customerId, updateFormData) => apiService.request({
    url: `/customers/${customerId}`,
    method: 'POST',
    payload: {
        externalReference: updateFormData.externalReference,
        //email: updateFormData.email,
        //mobilePhone: updateFormData.mobilePhone,
    }
});

export const getContacts = customerId => apiService.request({
    url: `/customers/${customerId}/contacts`,
    method: 'GET',
    parse: true,
    onResult: result => _.map(result, contact => _.assign({}, contact, {
        createdDate: utcToDisplayDate(contact.createdDate),
        createdAt: utcToDisplayDate(contact.createdAt),
    }))
});

export const getShippingOrders = (customerId) => apiService.request({
    url: `/customers/${customerId}/shippingOrders/`,
    method: 'GET',
    parse: true
});

export const getWorkOrders = (customerId) => apiService.request({
    url: `/customers/${customerId}/workOrders/`,
    method: 'GET',
    parse: true
});

export const getBasket = id => salesApiService.request({
    url: `/basket/${id}`,
    method: 'GET',
    parse: true,
    onResult: result => {
        if (result.customer) {
            result.customer = _.assign({}, result.customer, {
                birthDate: utcToDisplayDate(result.customer.birthDate)
            });
        }

        if (result.customerOffer) {
            result.customerOffer = _.assign({}, result.customerOffer, {
                givenAtUtc: utcToDisplayDate(result.customerOffer.givenAtUtc)
            });
        }

        return result;
    }
});

export const getCampaignsOverview = () => salesApiService.request({
    url: '/campaignsOverview',
    method: 'GET',
    parse: true,
    onResult: result => _.sortBy(result, ['name'])
});

export const getPrice = (id) => salesApiService.request({
    url: `/basket/${id}/price`,
    method: 'GET',
    parse: true
});

export const giveCustomerOffer = id => salesApiService.request({
    url: `/basket/${id}/customeroffer`,
    method: 'POST'
});

export const selectCampaign = (id, campaignId) => salesApiService.request({
    url: `/basket/${id}/campaign/${campaignId}`,
    method: 'POST'
});

export const setCustomer = (id, customer) => salesApiService.request({
    url: `/basket/${id}/customer`,
    method: 'PUT',
    payload: customer,
    onPayload: customer => _.assign({}, customer, { birthDate: displayDateToUtc(customer.birthDate) })
});

export const setAddress = (id, address, type) => salesApiService.request({
    url: `/basket/${id}/address/${type}`,
    method: 'POST',
    payload: address
});

export const setInstallationDetails = (id, installationDetails) => salesApiService.request({
    url: `/basket/${id}/installationDetails`,
    method: 'PUT',
    payload: installationDetails
});

export const setSalesRepresentative = (id, salesRepresentative) => salesApiService.request({
    url: `/basket/${id}/salesrepresentative`,
    method: 'PUT',
    payload: salesRepresentative
});

export const saveBasket = (id, basket) => salesApiService.request({
    url: `/basket/${id}`,
    method: 'POST',
    payload: basket,
    onPayload: basket => _.assign({}, basket, {
        customer: _.assign({}, basket.customer, {
            birthDate: displayDateToUtc(basket.customer.birthDate)
        })
    })
});

export const lookupMobile = mobile => salesApiService.request({
    url: `/person/mobilePhone/${mobile}`,
    method: 'GET',
    parse: true
});

export const lookupPerson = (firstName, lastName, birthDate) => salesApiService.request({
    url: `/person?firstName=${firstName}&lastName=${lastName}&birthDate=${displayDateToShortDate(birthDate)}`,
    method: 'GET',
    parse: true
});

export const toggleProductSelection = (id, basketProductId, isSelected) => salesApiService.request({
    url: `/basket/${id}/basketProductSelection`,
    method: 'PUT',
    payload: {
        basketProductId,
        isSelected
    }
});

export const toggleReceiverProductSelection = (id, basketProductId, receiverCategory, isSelected) => salesApiService.request({
    url: `/basket/${id}/basketReceiverProductSelection`,
    method: 'PUT',
    payload: {
        basketProductId,
        receiverCategory,
        isSelected
    }
});

export const cancelHardwareProduct = agreementDetailId => apiService.request({
    url: `/agreementdetails/${agreementDetailId}/cancelsoldhardware`,
    method: 'POST',
});

export const addHardwareProduct = (customerId, boxSerialNumber, cardSerialNumber, isBundledDevice) =>
    apiService.request({
        url: `/hardwareproducts`,
        method: 'POST',
        payload: {
            customerId,
            boxSerialNumber,
            cardSerialNumber,
            isBundledDevice
        }
    });


// ORDER PRODUCTS

export const orderNewHardwareProducts = (CustomerId, CommercialProductsWithOffers, CustomerOfferId, SkipShippingOrder = false) => 
    apiService.request({
        url: `/hardwareproducts/order`,
        method: 'POST',
        payload: {
            CustomerId,
            CustomerOfferId,
            SkipShippingOrder,
            HardwareProducts: CommercialProductsWithOffers         
        }
    });
    
export const orderNewSoftwareProducts = (CustomerId, CommercialProductsWithOffers, CustomerOfferId, ChannelIdList = []) =>
    apiService.request({
        url: `/softwareproducts/order`,
        method: 'POST',
        payload: {
            CustomerId,
            CustomerOfferId,
            ChannelIdList,
            SoftwareProducts: CommercialProductsWithOffers
        }
    });


export const fetchProductPrices = (customerId, productsList) => apiService.request({
    url: `/price/${customerId}`,
    method: 'POST',
    payload: productsList,
    parse: true
});


// Serials
export const saveSerial = (customerId, agreementDetailsId, hardwareDetails) => apiService.request({
    url: '/hardwareproducts/activate',
    method: 'POST',
    payload: { customerId, agreementDetailsId, hardwareDetails }
});

// CMS     
export const fetchProductOffers = () => {
    const query = `*[_type == "productOffer"] | order(name asc) {
        ...,
        "image": coalesce(image.asset->url, ""),
        products[] { commercialProduct->{_id, _type, name, commercialProductId }, offer-> { _id, name, offerId }}
    }`;
    return cmsService.getDocumentsByQuery(query);
}

export const fetchPartnerOffers = (partnerId) => {
    const query = `*[  _type == 'salesPartnerOffers' && partner._ref in *[_type == 'partner' && config.partnerId == '${partnerId}']._id][0] {
        offers[]-> {
            _id,
            offerId,
            label,
            'commercialProductId': product->iccProductId,
            contractPeriod,
            'name': product->name,
            'type': product->type,
            'image': product->profile.asset->url,
            product->
            },
       }`;
    return cmsService.getDocumentsByQuery(query);
}